import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import BakeryLanding from './components/BakeryLanding';
import Menu from './components/Menu/MenuPage.jsx';
import AboutPage from './components/Aboutus/AboutPage.jsx';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy.jsx';
import Menu2 from './components/Menu/Menupage2.jsx';

// Placeholder components for other pages
const AboutUs = () => (
  <div className="min-h-screen bg-orange-50 flex items-center justify-center">
    <h1 className="text-4xl font-bold text-cyan-900">About Us Page</h1>
  </div>
);

const Shop = () => (
  <div className="min-h-screen bg-orange-50 flex items-center justify-center">
    <h1 className="text-4xl font-bold text-cyan-900">Shop Page</h1>
  </div>
);

const Contact = () => (
  <div className="min-h-screen bg-orange-50 flex items-center justify-center">
    <h1 className="text-4xl font-bold text-cyan-900">Contact Page</h1>
  </div>
);

// 404 Not Found component
const NotFound = () => (
  <div className="min-h-screen bg-orange-50 flex flex-col items-center justify-center">
    <h1 className="text-6xl font-bold text-red-500 mb-4">404</h1>
    <h2 className="text-2xl font-semibold text-cyan-900 mb-4">Page Not Found</h2>
    <p className="text-lg text-slate-600 mb-8 text-center max-w-md">
      The page you're looking for doesn't exist or has been moved.
    </p>
    <button
      onClick={() => window.location.href = '/'}
      className="px-6 py-3 bg-red-500 text-white rounded-full font-bold hover:bg-red-600 transition-colors"
    >
      Go Home
    </button>
  </div>
);

function App() {
  // Get the current path to determine if we're in the correct base path
  const currentPath = window.location.pathname;
  const basePath = '/';

  // If we're not in the base path and not already redirected, redirect to base path
  if (!currentPath.startsWith(basePath) && currentPath !== '/') {
    window.location.href = basePath + '/';
    return null;
  }

  return (
    <Router basename="/">
      <div>
        <Routes>
          {/* Main routes */}
          <Route path="/" element={<BakeryLanding />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/menu2" element={<Menu2/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/PrivacyPolicy" element={<Navigate to="/privacy-policy" replace />} />

          {/* Catch all route for 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
